import React from 'react';
import { Box, Typography } from '@mui/material';
import { TOKENS } from '../state/colors';
import { fs } from '../state/typography';

interface ProgressRingProps {
  porcentaje: number; // 0..1
}

export const ProgressRing: React.FC<ProgressRingProps> = ({ porcentaje }) => {
  const size = 60;
  const radio = 23;
  const stroke = 7;
  const circunferencia = 2 * Math.PI * radio;
  const progreso = Math.max(0, Math.min(1, porcentaje));
  const offset = circunferencia * (1 - progreso);

  return (
    <Box sx={{ position: 'relative', width: size, height: size }} data-testid="progress-ring">
      <svg width={size} height={size} viewBox={`0 0 ${size} ${size}`}>
        <circle cx={size / 2} cy={size / 2} r={radio} fill="none" stroke={TOKENS.wash} strokeWidth={stroke} />
        <circle
          cx={size / 2}
          cy={size / 2}
          r={radio}
          fill="none"
          stroke={TOKENS.purple}
          strokeWidth={stroke}
          strokeLinecap="round"
          strokeDasharray={circunferencia}
          strokeDashoffset={offset}
          transform={`rotate(-90 ${size / 2} ${size / 2})`}
          style={{ transition: 'stroke-dashoffset .5s' }}
        />
      </svg>
      <Box sx={{ position: 'absolute', inset: 0, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <Typography sx={{ fontFamily: 'Poppins, sans-serif', fontSize: fs(12.5), fontWeight: 700, color: TOKENS.ink }}>
          {Math.round(progreso * 100)}%
        </Typography>
      </Box>
    </Box>
  );
};
